import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.LOGIN_PAGE]: {
    [ROLE.FORM]: [ELEMENT.LOGIN],
    [ROLE.BUTTON]: [ELEMENT.GO_BACK],
  },
} as TValidTestId;
